import { motion } from 'framer-motion';

const orbs = [
  { size: 120, x: '10%', y: '20%', duration: 18, delay: 0 },
  { size: 80, x: '75%', y: '15%', duration: 22, delay: 2 },
  { size: 60, x: '85%', y: '60%', duration: 20, delay: 4 },
  { size: 100, x: '20%', y: '70%', duration: 25, delay: 1 },
  { size: 40, x: '50%', y: '40%', duration: 16, delay: 3 },
  { size: 70, x: '60%', y: '80%', duration: 19, delay: 5 },
  { size: 50, x: '35%', y: '10%', duration: 23, delay: 2.5 },
];

const sparkles = [
  { x: '15%', y: '25%', delay: 0, duration: 3 },
  { x: '80%', y: '35%', delay: 1.2, duration: 2.5 },
  { x: '45%', y: '65%', delay: 0.5, duration: 3.5 },
  { x: '70%', y: '80%', delay: 2, duration: 2.8 },
  { x: '25%', y: '50%', delay: 1.8, duration: 3.2 },
  { x: '90%', y: '15%', delay: 0.8, duration: 2.6 },
  { x: '55%', y: '20%', delay: 3, duration: 3 },
  { x: '10%', y: '85%', delay: 1.5, duration: 2.4 },
];

const HeroParticles = () => {
  return (
    <div className="absolute inset-0 z-[1] pointer-events-none overflow-hidden">
      {/* Subtle Grid Overlay */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `
            linear-gradient(hsl(var(--primary) / 0.3) 1px, transparent 1px),
            linear-gradient(90deg, hsl(var(--primary) / 0.3) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
        }}
      />

      {/* Floating Neon Orbs */}
      {orbs.map((orb, i) => (
        <motion.div
          key={`orb-${i}`}
          className="absolute rounded-full will-change-transform"
          style={{
            width: orb.size,
            height: orb.size,
            left: orb.x,
            top: orb.y,
            background: `radial-gradient(circle, hsl(var(--neon-glow) / 0.15) 0%, hsl(var(--neon-glow) / 0.05) 40%, transparent 70%)`,
            filter: `blur(${orb.size * 0.3}px)`,
          }}
          animate={{
            x: [0, 30, -20, 15, 0],
            y: [0, -25, 15, -10, 0],
            scale: [1, 1.1, 0.95, 1.05, 1],
            opacity: [0.4, 0.7, 0.5, 0.8, 0.4],
          }}
          transition={{
            duration: orb.duration,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: orb.delay,
          }}
        />
      ))}

      {/* Shooting Light Streaks */}
      <div className="hero-streak hero-streak-1" />
      <div className="hero-streak hero-streak-2" />
      <div className="hero-streak hero-streak-3" />

      {/* Sparkle Dots */}
      {sparkles.map((s, i) => (
        <motion.div
          key={`sparkle-${i}`}
          className="absolute w-1 h-1 rounded-full bg-primary will-change-transform"
          style={{ left: s.x, top: s.y }}
          animate={{
            opacity: [0, 1, 0],
            scale: [0.5, 1.2, 0.5],
          }}
          transition={{
            duration: s.duration,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: s.delay,
          }}
        />
      ))}
    </div>
  );
};

export default HeroParticles;
